module.exports = __webpack_public_path__ + "static/media/default.c7547e00.png";